module.exports = __webpack_public_path__ + "img/mobFilter.e8f83aac.svg";